import { render, staticRenderFns } from "./advertManageList.vue?vue&type=template&id=532864f4&scoped=true"
import script from "./advertManageList.vue?vue&type=script&lang=js"
export * from "./advertManageList.vue?vue&type=script&lang=js"
import style0 from "./advertManageList.vue?vue&type=style&index=0&id=532864f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532864f4",
  null
  
)

export default component.exports